export enum MM07ForceCaseType {
    LIFT = 0,
    HOLD = 1,
    CARRY = 2,
    PULL_AND_PUSH = 3
}
